/*
Flexible Materials
  --bend <float> | inches | ('Inches of Bend')
  --coreType <string::combobox>
  --insideRadius <float> | inches
  --outsideRadius <float> | inches
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
*/

import {
  manufacturer,
  manufacturerNumber,
  name,
  computerEaseNumber
} from '@/modules/standardItems/schemas/baseHeaders'
import sheetStockHeaders from '@/modules/standardItems/schemas/sheetStock/headers'

export default [
  name(),
  manufacturer(),
  ...sheetStockHeaders(),
  {
    text: 'Core Type',
    value: 'coreType',
    sortable: true,
    sort: 'string'
  },
  manufacturerNumber(),
  computerEaseNumber(),
  {
    text: 'Bend (in)',
    value: 'bend',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Inside Radius (in)',
    value: 'insideRadius',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Outside Radius (in)',
    value: 'outsideRadius',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  }
]
